import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const AdvancePayment = {
	name: NAME,
	apiProvider,
	router,
};
